module.exports = __webpack_public_path__ + "media/icons/location-pin-2e50d90e.png";